/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Action_Carrier_ReturnedInputs */

const vi_order_action_carrier_returned = /** @type {(inputs: Order_Action_Carrier_ReturnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã hoàn về kho`)
};

/**

* @param {Order_Action_Carrier_ReturnedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_action_carrier_returned = /** @type {((inputs?: Order_Action_Carrier_ReturnedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Action_Carrier_ReturnedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_action_carrier_returned(inputs)
});